/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button, ModalConfirm } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { EmployeeRole } from "~/models";
import { generateActionConfirmText, useAxios } from "~/tools";

type UnassignRoleProps = {
  role: EmployeeRole;
  id: string;
  employeesId: string;
  deleteCallback: () => void;
};

function UnassignRole({
  role,
  deleteCallback,
  employeesId,
  id,
}: UnassignRoleProps) {
  const [isOpen, setIsOpen] = React.useState(false);
  const { showError } = useShowError();
  const { Axios } = useAxios();

  return (
    <>
      <Button
        onClick={() => setIsOpen(true)}
        type="button"
        css={{ marginLeft: "auto" }}
        size="sm"
        severity="medium"
        icon="brokenLink"
      />
      <ModalConfirm
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        confirm={async () => {
          try {
            await Axios().delete(
              `/customers/${id}/employees/${employeesId}/roles/${role?.id}`
            );
            setIsOpen(true);
            deleteCallback();
          } catch (e) {
            showError(e.response);
          }
          setIsOpen(false);
        }}
        actionLabel="Unassign"
        contentLabel="Unassign Role"
      >
        {generateActionConfirmText(`${role?.name} role`)("unassign")()}
      </ModalConfirm>
    </>
  );
}

export { UnassignRole };
